import { CashFlowPeriodType } from "@/models/interface/cash-flow-report/CashFlowReport.interface";

export interface CashFlowReportFilterParams {
  year: number;
  periodType: CashFlowPeriodType;
  quarterCount?: number;
  month?: number;
}

export interface CashFlowReportDownloadParams extends CashFlowReportFilterParams {
  params: string;
}

export function buildFilterParams(
  periodType: CashFlowPeriodType,
  year: number,
  month?: number,
  quarterCount?: number
): CashFlowReportFilterParams {
  const base: CashFlowReportFilterParams = { year, periodType };

  if (periodType === CashFlowPeriodType.MONTHLY) {
    return { ...base, month };
  }

  if (periodType === CashFlowPeriodType.QUARTERLY) {
    return { ...base, quarterCount };
  }

  return base;
}
